// extracted by mini-css-extract-plugin
export default {"container":"AppointmentDialog_container__z8n9Z","content":"AppointmentDialog_content__rQc-c","scrollArrow":"AppointmentDialog_scrollArrow__Q202n"};